import script from "./MainApp.vue?vue&type=script&setup=true&lang=js"
export * from "./MainApp.vue?vue&type=script&setup=true&lang=js"

import "./MainApp.vue?vue&type=style&index=0&id=ecc79ec6&lang=scss"

const __exports__ = script;

export default __exports__